import React from 'react';

import { useState, useEffect } from 'react';

import { Tag, Typography, Row, Col, Popconfirm, message, Avatar, Tabs, Modal } from 'antd';

import './guest-info.scss';

import { Location, ApiUtils, useTranslation, DateUtils, Card, Button } from 'soxo-bootstrap-core';

import StatusChange from '../../../appointment/components/status-change/status-change';

import PaymentLink from '../payment-link/payment-link';

import moment from 'moment';
import DisplayNature from '../display-nature/display-nature';

import { LinkOutlined } from '@ant-design/icons';

// const { t, i18n} = useTranslation();
const { Title, Text } = Typography;

let paidValues = {
    Y: 'Paid',
    N: 'Pending',
    P: 'Partially Paid',
};

export default function GuestInfo({
    guest = {},
    // data of process status
    // data = {},
    id,
    guestreg = {},
    guestdr = {},
    guestopreg = {},
    guestprereg = {},
    guestitm = {},
    guestitem = {},
    guestevent = {},
    params = {},
    urlParams = {},
    disableQuestionnaire = false,
    // nature,
    selected,
    showSendPaymentLink,
    cancelApp,
    props,
    sameDay,
}) {
    // Guest
    let { opbill = {} } = guest;

    if (!opbill) {
        opbill = { opb_paidflg: 'N' };
    }

    const [key, setKey] = useState(null);

    const { t, i18n } = useTranslation(); // To Translate to another language

    const { TabPane } = Tabs;

    // payment link
    const [isModalVisible, setIsModalVisible] = useState(false);

    useEffect(() => {
        // getToken(guest.da_id)
        if (guest && guest.appointment_id) getQuestionnaireKey(guest.appointment_id);
    }, [guest]);

    /**
     * Get the questionnaire key
     *
     * @param {*} id
     */
    async function getQuestionnaireKey(id) {
        const result = await ApiUtils.get({ url: `doctor-appointment/questionnaire-key/${id}` });

        setKey(result.key);
    }

    // for payment link model
    const handleClosePaymentLinkModal = () => {
        setIsModalVisible(false);
    };

    /**
     * New Registration
     *
     *
     */

    function register() {
        Location.navigate({
            url: `/new-registrations/registration?id=${guest.prereg_id}&appointmentId=${guest.appointment_id}&redirect=appointment`,
        });
    }

    //function to Reschedule Appointment
    function rescheduleAppointment(record) {
        let url = `/new-registrations/slots?da_doctorptr=${guest.doctor_ptr}&da_packagetypevalue=${guest.packagetypevalue}&appointId=${guest.appointment_id}`;

        Location.navigate({ url: url });
    }

    /**
     * Edit Registration
     *
     *
     */

    function editRegistration() {
        //function to Edit Appointmnet
        var date = moment(guestreg.da_date).format('DD/MM/YYYY');
        // Add time to da_date, to pass selected_time in the url for edit
        date = date + ' ' + guestreg.da_aptime;
        Location.navigate({
            url: `/new-registrations/edit-registration?id=${guestreg.op_id}&edit=true&redirect=registration`,
        });
    }

    // function proceedBilling() {
    //     // &prereg_id=10553&mode=Online

    //     let url = `/new-registration/bill?op_no=${guest.da_newopno}&opreg_id=${guest.da_referenceid}&da_id=${guest.da_id}&da_packagetypevalue=${guest.da_packagetypevalue}`;

    //     Location.navigate({ url: url });
    // }

    /**
     * Redirect to bill if the customer is registered but not billed
     */
    /**
     * Redirect to bill if the customer is registered but not billed
     */
    function registerProceedBilling() {
        Location.navigate({
            url: `/multiple-candidate/bill?op_no=${guestdr.da_newopno}&appointmentId=${guestdr.da_id}`,
        });
    }

    function proceedBilling() {
        Location.navigate({
            url: `/multiple-candidate/bill?op_no=${guest.op_no}&appointmentId=${guest.appointment_id}`,
        });
    }

    // //function to Start Questionnaire
    // function goQues(id, edit) {
    //     if (edit) {
    //         window.open(`${process.env.REACT_APP_QUES_KEY}/user/questionnaire?id=${id}&key=${key}&edit=true`, '_blank');
    //     } else {
    //         window.open(`${process.env.REACT_APP_QUES_KEY}/user/questionnaire?id=${id}&key=${key}`, '_blank');
    //     }
    // }

    function goQues(id, edit) {
        if (edit) {
            window.open(`${process.env.REACT_APP_QUES_KEY}/user/questionnaire?key=${key}&edit=true&index=${guest.branch_ptr}`, '_blank');
        } else {
            window.open(`${process.env.REACT_APP_QUES_KEY}/user/questionnaire?key=${key}&index=${guest.branch_ptr}`, '_blank');
        }
    }
    //function to Edit Appointmnet
    var date = moment(guest.appointment_date).format('DD/MM/YYYY');
    // Add time to appointmentdate, to pass selected_time in the url for edit
    date = date + ' ' + guest.appointment_time;

    // function editAppointment() {
    //     Location.navigate({
    //         url: `/new-registrations/edit-guest?da_id=${guest.da_id}&da_packagetypevalue=${guest.da_packagetypevalue}&id=${guest.da_referenceid}&prereg_opno=${guest.da_newopno}&selected_time=${date}&edit=true&redirect=appointment`,
    //     });
    // }

    //Appointment data fiiling for icarus
    // function CompleteProfile() {
    //     Location.navigate({
    //         url: `/new-registrations/complete-profile?da_id=${guest.da_id}&da_packagetypevalue=${guest.da_packagetypevalue}&id=${guest.da_referenceid}&prereg_opno=${guest.da_newopno}&selected_time=${date}&edit=true&redirect=appointment`,
    //     });
    // }

    //to check if Date of Birth is available
    var age = null;

    if (guestprereg && !guestprereg.prereg_dob) {
        age = guestprereg.prereg_ageyear;
    }

    //Apointmnet Guest Deatil

    if (guest.appointment_id) {
        return (
            <>
                {/* {(guestprereg?.prereg_batch_mode === 'PARENT' || guestprereg?.prereg_batch_mode === 'CHILD') ? (
                        <div>
                            <Button
                                size="middle"
                                type="primary"
                                style={{ marginRight: '5px' }}
                                onClick={CompleteProfile}
                            >
                                Complete Profile
                            </Button>
                        </div>
                    ) : null} */}

                {/*Guest Information */}

                <Card className="guest-info card card-shadow">
                    {/* <div>
                        <h6>{guest && guest.da_fname ? (guest.da_fname.toUpperCase()) : null} {guest && guest.da_lname ? (guest.da_lname.toUpperCase()) : null} booked an appointment for {moment(guest.da_time).format('dddd, MMM Do')}</h6>
                    </div> */}

                    {/*Guest Detail */}
                    <div>
                        <Title
                            // style={}
                            className="guest-headings"
                            level={5}
                        >
                            {t('GUEST INFORMATION')}
                            {guest && guest.nature ? <DisplayNature nature={guest.nature} /> : null}
                        </Title>
                    </div>
                    <div style={{ display: 'contents' }}>
                        {/* First Row */}

                        <Row gutter={[16, 16]}>
                            <Col xs={24} lg={8}>
                                <div style={{ display: 'flex', gap: '0.2rem' }}>
                                    <Avatar style={{ backgroundColor: 'gray', margin: 0 }} size="large">
                                        {guest.first_name.charAt(0).toUpperCase()}
                                    </Avatar>

                                    <div className="information">
                                        <div>
                                            <Text level={2} type="secondary">
                                                {t('NAME')}
                                            </Text>
                                        </div>
                                        <div>
                                            <span>
                                                <strong>
                                                    {guest && guest.title ? guest.title : null}{' '}
                                                    {guest && guest.first_name ? guest.first_name.toUpperCase() : null}{' '}
                                                    {guest && guest.last_name ? guest.last_name.toUpperCase() : null}{' '}
                                                </strong>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} lg={6}>
                                <div className="information">
                                    <Text type="secondary">{t('DATE')}</Text>
                                    <span>
                                        {/* <strong>{moment(guest.da_time).format('dddd, MMM Do')}</strong> */}
                                        <strong>{DateUtils.formatDate(guest.appointment_date)}</strong>
                                    </span>
                                </div>
                            </Col>
                            <Col xs={24} lg={2}>
                                <div className="information">
                                    <Text type="secondary">{t('AGE')}</Text>
                                    <span>
                                        <strong>{guest && guest.age ? guest.age : null}</strong>
                                    </span>
                                </div>
                            </Col>
                            <Col xs={24} lg={4}>
                                <div className="information">
                                    <Text type="secondary">{t('DOB')}</Text>
                                    <span>
                                        <strong>{guest?.dob ? moment(guest?.dob).format('DD-MM-YYYY') : null}</strong>
                                    </span>
                                </div>
                            </Col>
                            <Col xs={24} lg={4}>
                                <div className="information">
                                    <Text type="secondary">{t('GENDER')}</Text>
                                    <span>
                                        <strong>{guest && guest.gneder ? guest.gender : guest ? guest.gender : null}</strong>
                                    </span>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row */}
                        <Row gutter={[16, 16]}>
                            <Col xs={24} lg={8}>
                                <div className="information">
                                    <Text type="secondary">{t('ADDRESS')}</Text>
                                    {/* {guestprereg ? (
                                        (guestprereg && guestprereg.prereg_address1) || (guestprereg && guestprereg.prereg_address2) ? (
                                            <Row>
                                                <span>
                                                    <strong>
                                                        {guestprereg && guestprereg.prereg_address1 ? guestprereg.prereg_address1 : (guest ? guest.address1 : null)},
                                                        {/* <br /> */}
                                    {/* {guestprereg && guestprereg.prereg_address2 ? guestprereg.prereg_address2 : (guest ? guest.address2 : null)},
                                                        {/* <br /> */}
                                    {/* {guestprereg && guestprereg.prereg_zip ? guestprereg.prereg_zip : null} */}
                                    {/* </strong>
                                                </span>
                                            </Row>
                                        // ) :  */}
                                    {/* guest.op_no ? null : (
                                            <Row>
                                                <small style={{ color: 'orange' }}>{t('Remarks')}:{t('Address is Required')}</small>
                                            </Row>
                                        )
                                    ) : guest ? ( */}
                                    <Row>
                                        <span>
                                            <strong>
                                                {guest && guest.address1 ? guest.address1 : null}
                                                <br />
                                                {guest && guest.address2 ? guest.address2 : null}
                                                <br />
                                                {guest && guest.pincode ? guest.pincode : null}
                                                {/* {guestprereg && guestprereg.da_place ? guestprereg.da_place : null} */}
                                            </strong>
                                        </span>
                                    </Row>
                                    {/* // ) : null} */}
                                </div>
                            </Col>

                            <Col xs={24} lg={8}>
                                <div className="information">
                                    <Text type="secondary">{t('Email')}</Text>

                                    <span>
                                        {' '}
                                        <strong>{guest && guest.email_address ? guest.email_address : null} </strong>
                                    </span>
                                </div>
                            </Col>

                            <Col xs={24} lg={8}>
                                <div className="information">
                                    <Text type="secondary">{t('USERNAME')}</Text>

                                    <span>
                                        {' '}
                                        <strong>{guest && guest.user_name ? guest.user_name : null} </strong>
                                    </span>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]}>
                            <Col xs={24} lg={8}>
                                <div className="information">
                                    <Text type="secondary">{t('PHONE NUMBER')}</Text>

                                    <span>
                                        {' '}
                                        <strong>
                                            {guest?.phone_numer
                                                ? `${guest?.prereg_mobile1countrycode ? `+${guest.prereg_mobile1countrycode} ` : ''}${guest.phone_numer}`
                                                : ''}
                                        </strong>
                                    </span>
                                </div>
                            </Col>
                            {guest && guest.op_no ? (
                                <Col xs={24} lg={8}>
                                    <div className="information">
                                        <Text type="secondary">Nura ID </Text>

                                        <span>
                                            {' '}
                                            <strong>{guest && guest.op_no ? guest.op_no : null} </strong>
                                        </span>
                                    </div>
                                </Col>
                            ) : null}
                            {guest && guest.emirates_id ? (
                                <Col xs={24} lg={8}>
                                    <div className="information">
                                        <Text type="secondary">Emirates ID</Text>

                                        <span>
                                            {' '}
                                            <strong>{guest && guest.emirates_id ? guest.emirates_id : null} </strong>
                                        </span>
                                    </div>
                                </Col>
                            ) : null}
                        </Row>
                    </div>
                </Card>

                {/* appoinment information start */}
                {/* Package Name */}
                <Card className="guest-info card card-shadow">
                    <div>
                        <Title
                            className="guest-headings"
                            // style={}
                            level={5}
                        >
                            {t('APPOINTMENT INFORMATION')}
                        </Title>
                    </div>
                    <div style={{ display: 'contents' }}>
                        <Row>
                            <Col xs={24} lg={8}>
                                <div className="information">
                                    {/* Package */}
                                    <Text type="secondary">{t('PACKAGE')}</Text>
                                    <span>
                                        {' '}
                                        <strong>{guest && guest.package_name ? guest.package_name : null} </strong>
                                    </span>
                                </div>
                            </Col>
                            <Col xs={24} lg={6}>
                                <div className="information">
                                    {/*Token Number */}
                                    <Text type="secondary">{t('TOKEN NUMBER')}</Text>
                                    <span>
                                        {' '}
                                        <strong>{guest && guest.tokenno ? guest.tokenno : null} </strong>
                                    </span>
                                </div>
                            </Col>
                            <Col xs={24} lg={8}>
                                <div className="information">
                                    <Text type="secondary">{t('APPOINTMENT AT')}</Text>
                                    <div className="date-time-reschedule">
                                        <span>
                                            <strong>
                                                {moment(guest.appointment_date).format('DD/MM/YYYY')} {guest.appointment_time}
                                            </strong>
                                        </span>
                                        {guest.bill_id ? null : (
                                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                                                <Popconfirm
                                                    title={t('Are you sure you want to Reschedule this appointment ? ')}
                                                    onConfirm={() => rescheduleAppointment(guest)}
                                                    onCancel={() => {}}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <Button
                                                        size="small"
                                                        type="primary"
                                                        // type="link"
                                                        // shape="round"
                                                        // style={{ margin: '0px 10px' }}
                                                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'blue' }}
                                                    >
                                                        {t('Reschedule')}
                                                    </Button>
                                                </Popconfirm>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} lg={8}>
                                <div className="information">
                                    <Text className="guest-headings" type="primary">
                                        {t('PAYMENT STATUS')}
                                    </Text>
                                    <span>
                                        {guest && guest.process_info.payment_status_code === 'F' ? (
                                            <Tag color="green">{t('Paid')}</Tag>
                                        ) : (
                                            <Tag color="orange">{t('Pending')}</Tag>
                                        )}
                                    </span>
                                </div>
                            </Col>
                            <Col xs={24} lg={6}>
                                <div className="information">
                                    <Text type="secondary">{t('SOURCE')}</Text>
                                    <span>
                                        <strong>
                                            {guest.sourcet_ype === 'NDES'
                                                ? t('STAFF')
                                                : guest.sourcet_ype === 'WEB' || guest.sourcet_ype === 'NWEB'
                                                ? t('WEBSITE')
                                                : null}
                                        </strong>
                                    </span>
                                </div>
                            </Col>
                            <Col xs={24} lg={8}>
                                <div className="information">
                                    <Text type="secondary">{t('REMARKS')}</Text>
                                    <strong>{guest.remarks}</strong>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} lg={8}>
                                <div className="information">
                                    <Text type="secondary">{t('REFERRAL')}</Text>
                                    <span>
                                        {' '}
                                        <strong>{guest && guest.referrer_desc ? guest.referrer_desc : null} </strong>
                                    </span>
                                </div>
                            </Col>
                            <Col xs={24} lg={6}>
                                <div className="information">
                                    <Text type="secondary">{t('CORPORATE')}</Text>
                                    <span>
                                        {' '}
                                        <strong>{guest && guest.corporate_desc ? guest.corporate_desc : null} </strong>
                                    </span>
                                </div>
                            </Col>
                            <Col xs={24} lg={8}>
                                <div className="information">
                                    <Text type="secondary">{t('CREATED BY')}</Text>
                                    <span>
                                        <strong>{guest && guest.user ? guest.user : null}</strong>
                                    </span>
                                </div>
                            </Col>
                            {/* <Col span={8}>
                                <div className="information">
                                    <Text type="secondary">{t('PAYMENT LINK')}</Text>
                                    <strong>{guest.remarks}</strong>

                                    <span>{data && data.payment_status_code === 'F' ? <Tag color="green">{t('Paid')}</Tag> : <Tag color="orange">{t('Pending')}</Tag>}</span>
                                </div>
                            </Col> */}
                            {/* send payment Link start */}
                            <Col xs={24} lg={8}>
                                {guest && guest.process_info.payment_status_code === 'P' && props.showSendPaymentLink ? (
                                    <div className="information">
                                        {/* <div className="section-label"> */}
                                        <Text type="secondary">{t('PAYMENT LINK')}</Text>
                                        {/* </div> */}

                                        {/* <div className="section-value"> */}
                                        <span>
                                            <Button
                                                size="small"
                                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'blue' }}
                                                type="secondary"
                                                onClick={() => {
                                                    setIsModalVisible(true);
                                                }}
                                            >
                                                <LinkOutlined />
                                                {t('Send Payment Link')}
                                            </Button>
                                            {/*  Payment Link modal starts  */}
                                            <Modal
                                                destroyOnClose={true}
                                                footer={null}
                                                className="payment"
                                                visible={isModalVisible}
                                                //  onOk={() => {
                                                //     setVisible(true);
                                                //      }}

                                                onCancel={() => {
                                                    setIsModalVisible(false);
                                                }}
                                                width={'40%'}
                                                maskClosable={false}
                                            >
                                                <Tabs defaultActiveKey="0">
                                                    <LinkOutlined />
                                                    <TabPane tab="SEND PAYMENT LINK" key="0">
                                                        {guest ? (
                                                            <PaymentLink
                                                                callback={handleClosePaymentLinkModal}
                                                                // mail={guestprereg.prereg_email}
                                                                guest={guest}
                                                                // guestItem={guestitem}
                                                                discount={guest.coupon_no ? guest.coupon_value : null}
                                                                selected={selected}
                                                                props={props}
                                                            />
                                                        ) : null}
                                                    </TabPane>
                                                </Tabs>
                                            </Modal>
                                            {/* Payment Link Model end */}
                                            {/* </div> */}
                                        </span>
                                    </div>
                                ) : null}
                                {/* send payment Link end */}
                                {/* </div> */}
                            </Col>
                            <Col span={8} xs={24} lg={6}>
                                {props.hideScreenStatus ? null : (
                                    <div className="information">
                                        <Text type="secondary">{t('SCREENING STATUS')}</Text>
                                        <StatusChange
                                            // description={status.app_status}
                                            // callback={handleStandAlone}
                                            id={guest.appointment_id}
                                            // statusValue={status.app_status_code}
                                            // status mode
                                            mode="GST"
                                            // mode of status for api call
                                            apiMode="GUST"
                                            name="Screening Status"
                                            standalone={true}
                                        />
                                    </div>
                                )}
                            </Col>
                        </Row>
                        {/* <Row>
                           
                        </Row> */}
                        <Row gutter={[16, 0]}>
                            <Col>
                                {guest.canflg !== '*' && (
                                    <div className="information-button">
                                        <Button
                                            type="primary"
                                            size="small"
                                            disabled={guest.op_no || sameDay === false ? true : false || guest.reference_id == -1}
                                            onClick={register}
                                        >
                                            {t('Register')}
                                        </Button>
                                        {/* Cancel Appointment */}
                                        {!guest.bill_id ? (
                                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                                                <Popconfirm
                                                    title={t('Are you sure you want to cancel this appointment?')}
                                                    onConfirm={() => cancelApp()}
                                                    onCancel={() => {}}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <Button
                                                        className="billing"
                                                        size="small"
                                                        type="default"
                                                        style={{ paddingBottom: '1rem', border: '1px solid red', color: 'red' }}
                                                    >
                                                        {t('Cancel Appointment')}
                                                    </Button>
                                                </Popconfirm>
                                            </div>
                                        ) : null}
                                        {(guest.op_no && sameDay && !guest.bill_id) || (!guest.op_no && guest.prereg_opno) ? (
                                            <Button size="small" type="secondary" onClick={proceedBilling}>
                                                {t('Proceed to Bill')}
                                            </Button>
                                        ) : null}
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </div>

                    {/*Registration Number */}

                    {/* <div className="detail-element-card">
                            <Row span={12}>
                                <span>Registered Status</span>
                            </Row>
                            <Row span={12}>
                                <span>{guestopreg && guestopreg.op_no ? <Tag color="green">Booked</Tag> : <Tag color="orange">Pending</Tag>}</span>
                            </Row>
                        </div> */}

                    {/*Consent Status */}
                    {/* <div className="detail-element-card">
                            <Row span={12}>
                                <span>Consent Status</span>
                            </Row>
                            <Row span={12}>
                                <span>{guest.da_consentfilled ? <Tag color="green">Submitted</Tag> : <Tag color="orange">Pending</Tag>}</span>
                            </Row>
                        </div> */}

                    {/*Payment Status */}
                    {/* <div className="detail-element-card">
                            <Row span={12}>
                                <span>Bill Paid</span>
                            </Row>
                            <Row span={12}>
                                <Tag color={opbill.opb_paidflg === 'Y' ? 'green' : 'orange'}>{paidValues[opbill.opb_paidflg]}</Tag>

                            </Row>
                        </div> */}
                </Card>
                {/*Questionnaire Status */}
                <Card className="card card-shadow">
                    <Row justify="space-between" align="middle">
                        {/* Left side: Title */}
                        <Col>
                            <Title level={5} className="guest-headings">
                                {t('QUESTIONNAIRE STATUS')}
                            </Title>
                        </Col>

                        {/* Right side: Status, Buttons */}
                        <Col>
                            <div className="questinnair-status">
                                <span>
                                    {guest.questfilled === 'F' ? <Tag color="green">{t('Filled')}</Tag> : <Tag color="orange">{t('Pending')}</Tag>}
                                </span>

                                {/* Show questionnaire buttons based on conditions */}
                                {key && guest.reference_id !== -1 ? (
                                    <Button size="small" type="primary" onClick={() => goQues(guest.appointment_id, guest.questfilled === 'F')}>
                                        {guest.questfilled === 'F' ? t('Edit Questionnaire') : t('Start Questionnaire')}
                                    </Button>
                                ) : (
                                    <small>Complete the Profile to fill the Questionnaire</small>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Card>

                {/* </div> */}
                {/* <div className="information card-shadow card"> */}
                {/* <span>REGISTRATION INFORMATION</span> */}

                {/* <div className="information-right"> */}
                {/* <span> {guest.da_questfilled === 'F' ? <Tag color="green">Filled</Tag> : <Tag color="orange">Pending</Tag>}</span> */}
                {/* <span> */}
                {/* <Button */}
                {/* onClick={() => { */}
                {/* Locati on.navigate({ url: `/appointment/${record.appointment.id}` }); */}
                {/* }} */}
                {/* type="secondary" */}
                {/* size="small" */}
                {/* color="green" */}
                {/* style={{ background: '#DCDFE4', color: '#626F86' }} */}
                {/* > */}
                {/* View */}
                {/* {t('View')} */}
                {/* </Button> */}
                {/* </span> */}
                {/* </div> */}
                {/* </div> */}

                {/* Billing Information */}

                <Card className="guest-info card card-shadow">
                    <Row justify="space-between" align="middle">
                        {/* Title Section */}
                        <Col>
                            <Title level={5} className="guest-headings">
                                {t('REGISTRATION INFORMATION')}
                            </Title>
                        </Col>

                        {/* Status Section */}
                        <Col>
                            <Tag color={guest.process_info.billed_status === 'Billed' ? 'green' : 'orange'}>
                                {guest.process_info.billed_status === 'Billed' ? t('Billed') : t('Pending')}
                            </Tag>
                        </Col>

                        {/* Optional View Button */}
                        {guest.da_billid && (
                            <Col>
                                <Button onClick={proceedBilling} type="default" size="small" style={{ background: '#DCDFE4', color: '#626F86' }}>
                                    {t('View')}
                                </Button>
                            </Col>
                        )}
                    </Row>
                </Card>

                {/* <Avatar shape="square" size={64} icon={<UserOutlined />} /> */}
            </>
        );
    } else if (guestreg) {
        // /Registration Details

        return (
            <>
                {guestdr.da_billid ? null : (
                    <div className="edit-appointment">
                        {/* <Button
                            onClick={() => {
                                Location.navigate({
                                    url: `/new-registration/guest?da_id=${guest.da_id}&da_packagetypevalue=${guest.da_packagetypevalue}&prereg_id=${guest.da_referenceid}&prereg_opno=${guest.da_newopno}&edit=true&redirect=registration`,
                                });
                            }}
                            type="ghost"
                            size={'small'}
                            shape="round"
                            style={{ background: '#FAC141', justifyContent: ' space-between"' }}
                        >
                            Edit Registration
                        </Button> */}
                    </div>
                )}

                {/*Guest Details */}
                <Card className="guest-info card ">
                    <>
                        {/*Display Patient Nature */}
                        {/* {nature ? (<DisplayNature nature={nature} />) : null} */}
                    </>

                    <div gutter={0} className="detail-wrapper">
                        <div className="detail-element">
                            <Row span={12}>
                                <span className="details">{t('Name')}</span>
                            </Row>
                            <Row span={12}>
                                <span>
                                    <strong>
                                        {guestreg.op_fname ? guestreg.op_fname.toUpperCase() : null}{' '}
                                        {guestreg.op_lname ? guestreg.op_lname.toUpperCase() : null} ({guestreg.op_gender ? guestreg.op_gender : null}
                                        ) - {guestreg.op_age ? guestreg.op_age : null}
                                    </strong>
                                </span>
                            </Row>
                        </div>

                        <div className="detail-element">
                            <Row span={12}>
                                <span className="details">{t('Address')}</span>
                            </Row>
                            <Row span={12}>
                                <span>
                                    <strong>
                                        {guestreg.op_add1 ? guestreg.op_add1 : null}
                                        <br />
                                        {guestreg.op_add2 ? guestreg.op_add2 : null}
                                        <br />
                                        {guestreg.op_place ? guestreg.op_place : null}
                                    </strong>
                                </span>
                            </Row>
                        </div>
                        <div className="detail-element">
                            <Row span={12}>
                                <span className="details">{t('Contact')}</span>
                            </Row>
                            <Row span={12}>
                                <span>
                                    <strong>
                                        {guestreg?.op_mobile
                                            ? `${guestreg?.op_mobcountrycode ? `+${guestreg.op_mobcountrycode} ` : ''}${guestreg.op_mobile}`
                                            : guest?.da_mobile
                                            ? guest.da_mobile
                                            : ''}
                                    </strong>
                                </span>
                            </Row>
                        </div>

                        {/* <div className="detail-element-card">
                            <Row span={12}>
                                <span className="details">OP No</span>
                            </Row>
                            <Row span={12}>
                                <span>
                                    <strong>{params.id}</strong>
                                </span>
                            </Row>
                        </div> */}
                        <div className="detail-element-card">
                            <Row span={12}>
                                <span className="details">{t('Email')}</span>
                            </Row>
                            <Row span={12}>
                                <span>
                                    <strong>{guestreg && guestreg.op_email ? guestreg.op_email : null}</strong>
                                </span>
                            </Row>
                        </div>
                        <div className="detail-element-card">
                            <Row span={12}>
                                <Text type="secondary">{t('UserName')}</Text>
                            </Row>
                            <Row span={12}>
                                <span>
                                    <strong>{guestprereg ? guestprereg.prereg_username : null}</strong>
                                </span>
                            </Row>
                        </div>
                        {/*Appointmnet Time */}
                        <div className="detail-element-card">
                            <Row span={12}>
                                <span className="details">{t('Appointment Time')}</span>
                            </Row>
                            <Row span={12}>
                                <span>
                                    <strong>
                                        {moment(guestdr.da_date).format('DD/MM/YYYY')} {guestdr.da_aptime}
                                    </strong>
                                </span>
                            </Row>
                        </div>
                        {/*Package Name */}
                        <div className="detail-element-card">
                            <Row span={12}>
                                <span className="details">{t('Package')}</span>
                            </Row>
                            <Row span={12}>
                                <span>
                                    <strong>{guestitm.itm_desc ? guestitm.itm_desc : null}</strong>
                                </span>
                            </Row>
                        </div>
                        {(guestreg?.op_othernatid1 || guestprereg.prereg_othernatid1) && (
                            <div className="detail-element-card">
                                <Row span={12}>
                                    <span className="details">{t('Emirates ID')}</span>
                                </Row>
                                <Row span={12}>
                                    <span>
                                        <strong>
                                            {guestreg && guestreg.op_othernatid1
                                                ? guestreg.op_othernatid1
                                                : guestprereg.prereg_othernatid1
                                                ? guestprereg.prereg_othernatid1
                                                : null}
                                        </strong>
                                    </span>
                                </Row>
                            </div>
                        )}
                        {/*Questionnaire Status */}
                        <div className="guest-info card ">
                            <div className="detail-element-card">
                                <Row span={12}>
                                    <span className="details">{t('Questionnaire Status')}</span>
                                </Row>
                                {guestdr.da_questfilled === 'F' ? (
                                    <Row span={12}>
                                        <Tag color="green">{t('Filled')}</Tag>
                                    </Row>
                                ) : (
                                    <Row>
                                        <Tag color="orange">{t('Pending')}</Tag>
                                        {/* {guest.da_questfilled === 'F' ?
                                        <Button
                                            size="middle"
                                            type="ghost"
                                            shape="round"
                                            style={{ marginTop: '10px', background: '#FAC141', justifyContent: ' space-between' }}
                                            onClick={() => {
                                                goQues(guest.da_id, true);
                                            }}
                                        >
                                            Edit Questionnaire
                                        </Button>
                                    ) : (
                                        <Button
                                            size="middle"
                                            type="ghost"
                                            shape="round"
                                            style={{ marginTop: '10px', background: '#FAC141', justifyContent: ' space-between' }}
                                            onClick={() => {
                                                goQues(guest.da_id);
                                            }}
                                        >
                                            Start Questionnaire


                                        </Button>} */}
                                    </Row>
                                )}
                            </div>
                        </div>
                        {/*Consent Form Status */}
                        <div className="detail-element-card">
                            <Row span={12}>
                                <span className="details">{t('Consent Status')}</span>
                            </Row>
                            {guestdr.da_consentscannedstatus ? (
                                <Row span={12}>
                                    <Tag color="green">{t('Submitted')}</Tag>
                                </Row>
                            ) : (
                                <Row span={12}>
                                    <Tag color="orange">{t('Pending')}</Tag>
                                </Row>
                            )}
                        </div>

                        {/*Payment Status */}

                        <div className="detail-element-card">
                            <Row span={12}>
                                <span className="details">{t('Payment Status')}</span>
                            </Row>
                            {guestdr.da_billid ? (
                                <Row span={12}>
                                    <Tag color="green">{t('Paid')}</Tag>
                                </Row>
                            ) : (
                                <Row span={12}>
                                    <Tag color="orange">{t('Pending')}</Tag>
                                </Row>
                            )}
                        </div>

                        {/*Current Status */}
                        {guestevent.Subevtm_desc ? (
                            <>
                                <div className="detail-element-card">
                                    <Row span={12}>
                                        <span className="details">{t('Current Status')}</span>
                                    </Row>
                                    <Row span={12}>
                                        <span>
                                            <strong>{guestevent.Subevtm_desc}</strong>
                                        </span>
                                    </Row>
                                </div>

                                <div className="detail-element-card">
                                    <Row span={12}>
                                        <span>{t('Current Status Remarks')}</span>
                                    </Row>
                                    <Row span={12}>
                                        <span>
                                            <strong>{guestevent.Subevtm_remarks}</strong>
                                        </span>
                                    </Row>
                                </div>
                            </>
                        ) : null}
                    </div>
                </Card>
                <div>
                    {guestdr.da_newopno && !guestdr.da_billid ? (
                        <>
                            <div>
                                <Row>
                                    <div>
                                        <Button
                                            className="billing"
                                            onClick={() => {
                                                registerProceedBilling();
                                            }}
                                            type="secondary"
                                            // size="small"
                                            color="green"
                                        >
                                            {t('Proceed for Billing')}
                                        </Button>
                                    </div>
                                </Row>
                            </div>
                        </>
                    ) : null}
                </div>

                <Button onClick={editRegistration}>{t('Edit')}</Button>
            </>
        );
    }
}
